import '@babel/polyfill'
import promise from 'es6-promise'; 
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import './router/http' // 引入axios
import './other/ivewImport'  // ivew 模块引入  
import './other/plugin' // 所有引入的第三方插件
import axios from 'axios'
import dateTool from 'date-and-time' 
axios.prototype.$https = axios
import './assets/scss/my-theme/my-theme.less'
import './assets/scss/index.scss'
import directives from './directive/directive.js';
import myService from './services/service'; // 将请求封装 
import VueCookies from 'vue-cookies'
import '../static/swiper.min.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueI18n from 'vue-i18n';
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
//import echarts from 'echarts'
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper)
// promise.polyfill();
Vue.use(myService);
Vue.use(VueCookies)
Vue.locale = () => {};

const messages = {
  en: Object.assign(en),
  zh: Object.assign(zh)
};


const i18n = new VueI18n({
  locale: 'zh',  // set locale
  silentTranslationWarn: true,
  messages  // set locale messages

});

import moment from 'moment';
Vue.filter('moment', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern);
})
//Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(router)

//全局过滤器
Vue.filter('dateFormat', function (value) {
  return dateTool.format(new Date(value),"YYYY-MM-DD HH:mm:ss")
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
